"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainScopes = exports.OrderGuideItemEventActions = exports.EventTypes = void 0;
var EventTypes;
(function (EventTypes) {
    EventTypes["OGItemEvent"] = "OGItemEvent";
})(EventTypes = exports.EventTypes || (exports.EventTypes = {}));
var OrderGuideItemEventActions;
(function (OrderGuideItemEventActions) {
    OrderGuideItemEventActions["OGItemCreated"] = "OGItemCreated";
    OrderGuideItemEventActions["OGItemUpdated"] = "OGItemUpdated";
    OrderGuideItemEventActions["OGItemDeleted"] = "OGItemDeleted";
    OrderGuideItemEventActions["CreateOGItem"] = "CreateOGItem";
    OrderGuideItemEventActions["UpdateOGItem"] = "UpdateOGItem";
    OrderGuideItemEventActions["DeleteOGItem"] = "DeleteOGItem";
})(OrderGuideItemEventActions = exports.OrderGuideItemEventActions || (exports.OrderGuideItemEventActions = {}));
var DomainScopes;
(function (DomainScopes) {
    DomainScopes["MyOrderGuideItemChanges"] = "MyOrderGuideItemChanges";
})(DomainScopes = exports.DomainScopes || (exports.DomainScopes = {}));
